import { SelectProps } from 'antd';
import { useState } from 'react';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import { useStockItems } from '@/core/domain/stock/StockItems/StockItems.hooks';
import {
  ListStockItemsQuery,
  StockItemType,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { flatInfiniteResult } from '@/utils/request/flatInfiniteResult';
import { useDebounce } from '@/hooks';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListStockItemsQuery;
};

const PartsInfiniteSelectField = ({ queryFilter, ...props }: Props) => {
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const { data, isFetching, hasNextPage, fetchNextPage } = useStockItems(true, {
    ...queryFilter,
    active: true,
    search,
    itemType: StockItemType.Part,
  });

  const stockItems = flatInfiniteResult(data);

  return (
    <InfiniteSelect
      {...props}
      options={stockItems.map((item) => ({
        label: item.description,
        value: item.partId,
      }))}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      loading={isFetching}
    />
  );
};

export default PartsInfiniteSelectField;
